import { useContext } from "react";
import { AuthenticationStateContext } from "@/providers/AuthenticationProvider/AuthenticationProvider";

export function useAuthenticationState() {
  const { authState, actions } = useContext(AuthenticationStateContext);

  return {
    authState,
    actions,
  };
}
